// ---------------------  Filter products based on checkboxes START--------------------- //

const filters = document.querySelectorAll('.filter');
const products = document.querySelectorAll('.product');
const specsTable = document.querySelector('.specs_table_container');
const noProductMessage = document.querySelector('.no_product_message_container');

function filterProducts() {
  const selectedFilters = Array.from(filters)
    .filter(filter => filter.checked)
    .map(filter => filter.value);

  let anyProductMatches = false;

  products.forEach(product => {
    const productClasses = product.className.split(' ');
    const productMatchesFilter = selectedFilters.every(filter => productClasses.includes(filter));

    if (productMatchesFilter) {
      product.style.display = 'flex';
      anyProductMatches = true;
    } else {
      product.style.display = 'none';
    }
  })

  if (!anyProductMatches) {
    noProductMessage.style.display = 'flex';
    specsTable.style.display = 'none';
  } else {
    noProductMessage.style.display = 'none';
    specsTable.style.display = 'flex';
  }
}

filters.forEach(filter => {
  filter.addEventListener('change', filterProducts);
});

// ---------------------  Filter products based on checkboxes END --------------------- //

// ---------------------  Filter products based on dropdowns START --------------------- //

// Filter products
function dropDownFilterProducts() {
  const filters = {};

  // Gather filter values
  document.querySelectorAll('.select_filter').forEach(filter => {
    const filterName = filter.getAttribute('data-filter');
    const filterValue = filter.value;
    if (filterValue !== 'default') {
      filters[filterName] = filterValue;
    }
  });

  let anyProductVisible = false;

  // Filter products
  document.querySelectorAll('.product').forEach(product => {
    let showProduct = true;

    for (let filterName in filters) {
      if (!product.classList.contains(filters[filterName])) {
        showProduct = false;
        break;
      }
    }

    if (showProduct) {
      anyProductVisible = true;
    }

    product.style.display = showProduct ? 'flex' : 'none';
  });

  // Update visibility of message and specs table
  const noProductMessage = document.querySelector('.no_product_message_container');
  const specsTable = document.querySelector('.specs_table_container');

  if (anyProductVisible) {
    if (noProductMessage) noProductMessage.style.display = 'none';
    if (specsTable) specsTable.style.display = 'flex';
  } else {
    if (noProductMessage) noProductMessage.style.display = 'flex';
    if (specsTable) specsTable.style.display = 'none';
  }
}


// Attach event listeners to dropdowns
document.querySelectorAll('.select_filter').forEach(filter => {
  filter.addEventListener('change', dropDownFilterProducts);
});

// ---------------------  Filter products based on dropdowns END --------------------- //

// Function to handle change in all dropdowns
document.querySelectorAll('.filter').forEach(function (dropdown) {
  dropdown.addEventListener('change', function () {
    if (this.value === "default") {
      this.classList.remove('selected');
    } else {
      this.classList.add('selected');
    }
  });
});

// ---------------------  Only one checkbox selected at a time function START --------------------- //

function handleCheckboxChange(checkboxNumber) {
  let start, end;
  if (checkboxNumber >= 1 && checkboxNumber <= 4) {
    start = 1;
    end = 4;
  } else if (checkboxNumber >= 5 && checkboxNumber <= 8) {
    start = 5;
    end = 8;
  } else if (checkboxNumber >= 9 && checkboxNumber <= 12) {
    start = 9;
    end = 12;
  } else if (checkboxNumber >= 13 && checkboxNumber <= 16) {
    start = 13;
    end = 16;
  }

  if (start !== undefined && end !== undefined) {
    for (let i = start; i <= end; i++) {
      if (i !== checkboxNumber) {
        document.getElementById("checkbox_" + i).checked = false;
      }
    }
  }
}

// ---------------------  Only one checkbox selected at a time function END --------------------- //

// ---------------------  Function to check checkboxes based on URL hash START --------------------- //

function checkCheckboxesFromURLHash() {
  const hash = window.location.hash.substr(1);

  if (hash.startsWith('checkbox_')) {
    document.getElementById('loader').style.display = 'block';

    const checkbox = document.getElementById(hash);
    if (checkbox) {
      checkbox.checked = true;
      const name = checkbox.getAttribute('name');
      const combinedId = name + '_' + hash.substr(hash.lastIndexOf('_') + 1);
      const highlight = document.getElementById(combinedId);
      console.log(highlight);
      if (highlight) {
        highlight.classList.add('button_checked');
      }
    }

    setTimeout(function () {
      filterProducts();

      document.getElementById('loader').style.display = 'none';
    }, 1000);
  }
}

window.onload = function () {
  checkCheckboxesFromURLHash();
};
// ---------------------  Function to check checkboxes based on URL hash END --------------------- //

// ---------------------  Grab Scrolling START --------------------- //

const scrollable = document.querySelector('.scrollable');

let isDragging = false;    // Flag to track if dragging is active
let startX, scrollLeft, startY, scrollTop;

// Mouse down event to start dragging
scrollable.addEventListener('mousedown', (e) => {
  isDragging = true;
  scrollable.classList.add('active'); // Add class for active state
  startX = e.pageX - scrollable.offsetLeft;
  startY = e.pageY - scrollable.offsetTop;
  scrollLeft = scrollable.scrollLeft;
  scrollTop = scrollable.scrollTop;
  scrollable.style.userSelect = 'none'; // Disable text selection
});

// Mouse leave event to stop dragging
scrollable.addEventListener('mouseleave', () => {
  isDragging = false;
  scrollable.classList.remove('active');
  scrollable.style.userSelect = ''; // Enable text selection
});

// Mouse up event to stop dragging
scrollable.addEventListener('mouseup', () => {
  isDragging = false;
  scrollable.classList.remove('active');
  scrollable.style.userSelect = ''; // Enable text selection
});

// Mouse move event to handle dragging
scrollable.addEventListener('mousemove', (e) => {
  if (!isDragging) return;  // Only run this code if dragging is true
  e.preventDefault();       // Prevent default behavior like text selection

  const x = e.pageX - scrollable.offsetLeft;
  const y = e.pageY - scrollable.offsetTop;

  const walkX = x - startX; // Calculate the distance moved horizontally
  const walkY = y - startY; // Calculate the distance moved vertically

  scrollable.scrollLeft = scrollLeft - walkX; // Update scroll position
  scrollable.scrollTop = scrollTop - walkY;   // Update scroll position
});

// Touch start event for mobile devices
scrollable.addEventListener('touchstart', (e) => {
  isDragging = true;
  startX = e.touches[0].pageX - scrollable.offsetLeft;
  startY = e.touches[0].pageY - scrollable.offsetTop;
  scrollLeft = scrollable.scrollLeft;
  scrollTop = scrollable.scrollTop;
});

// Touch end event for mobile devices
scrollable.addEventListener('touchend', () => {
  isDragging = false;
});

// Touch move event for mobile devices
scrollable.addEventListener('touchmove', (e) => {
  if (!isDragging) return;
  e.preventDefault();

  const x = e.touches[0].pageX - scrollable.offsetLeft;
  const y = e.touches[0].pageY - scrollable.offsetTop;

  const walkX = x - startX;
  const walkY = y - startY;

  scrollable.scrollLeft = scrollLeft - walkX;
  scrollable.scrollTop = scrollTop - walkY;
});

// ---------------------  Grab Scrolling END --------------------- //

// ---------------------  Setting detail container height START --------------------- //

function checkMaxHeight() {
  var elements = document.querySelectorAll('.item_img_title_price_container');
  var maxHeight = 0;

  // Iterate over the elements to find the maximum height
  elements.forEach(function (element) {
    var elementHeight = element.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });

  // Set all elements to the maximum height found
  elements.forEach(function (element) {
    element.style.height = maxHeight + 'px';
  });
}
document.addEventListener('DOMContentLoaded', checkMaxHeight);

window.addEventListener('resize', checkMaxHeight);

// ---------------------  Setting detail container height END --------------------- //
